import { useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { PAYMENT_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type Plan = {
  id: string
  name: 'Premium' | 'Enterprise'
  ui_metadata: {
    discounted_price?: number
    additional_user_price?: number
    features: string[]
  }
}

export const fetchPlans = async (): Promise<{
  status: 'error' | 'ok'
  data: Plan[] | null
  error?: string
}> => {
  try {
    const url = `${PAYMENT_SERVICE_BASE_URL}/subscriptions/plans`
    const response = await axios.get(url)

    return extract.data(response)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message,
    }
  }
}

export const useSubscriptionPlans = () => {
  return useQuery({
    queryKey: ['subscriptionPlans'],

    queryFn: async () => {
      const { data } = await fetchPlans()
      return data
    },
  })
}
